import { render, staticRenderFns } from "./Capa.vue?vue&type=template&id=2397857f&scoped=true&"
import script from "./Capa.vue?vue&type=script&lang=js&"
export * from "./Capa.vue?vue&type=script&lang=js&"
import style0 from "./Capa.vue?vue&type=style&index=0&id=2397857f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397857f",
  null
  
)

export default component.exports